import { intl } from '../../../../lib';
import { createRoot } from 'react-dom/client';
import { Icon } from '../../../basic';
import React from 'react';
import { EhsFormioComponents } from '../EhsFormioComponents';
import type { FormioBuilderInfo, FormioBuilderSchema } from '../index';
import type { ExtendedComponentSchema } from 'formiojs';

export const EhsFormioDataGridType = 'ehsDataGrid';

export class EhsFormioDataGrid extends EhsFormioComponents.components.datagrid {
  static schema(
    extend: FormioBuilderSchema
  ): ExtendedComponentSchema<FormioBuilderSchema> {
    return EhsFormioComponents.components.field.schema({
      ...extend,
      type: EhsFormioDataGridType
    });
  }

  static get builderInfo(): FormioBuilderInfo {
    return {
      title: 'Ehs Data Grid',
      group: 'data',
      icon: 'fa fa-table',
      weight: 50,
      documentation: '/developers/custom-components',
      schema: EhsFormioDataGrid.schema({
        type: EhsFormioDataGridType,
        label: 'Data Grid',
        key: 'dataGrid'
      })
    };
  }

  attach(element: HTMLElement): Promise<unknown> {
    element
      .querySelectorAll('.formio-button-remove-row')
      .forEach(createTrashIconForRepeatingQuestions);

    element.querySelectorAll('tbody tr').forEach(createColumnNumbering);

    element
      .querySelectorAll('table')
      .forEach(table => table.setAttribute('role', 'grid'));

    return super.attach(element);
  }
}

const createColumnNumbering = (row: Element, index: number) => {
  const lastTd = row.querySelector('td:last-child');
  if (!lastTd) {
    return;
  }

  const lastTdDoesntHaveNumberingAndRemoveButton =
    !lastTd.querySelector('.datagrid-column-number') &&
    lastTd.querySelector('button');

  if (lastTdDoesntHaveNumberingAndRemoveButton) {
    const numberingContainer = document.createElement('div');
    numberingContainer.classList.add('datagrid-column-number-container');
    numberingContainer.innerText = `${index + 1}.`;
    lastTd.appendChild(numberingContainer);
  }
};

/**
 * Create a trash icon for the repeating questions.
 *
 * @param button the button element
 */
const createTrashIconForRepeatingQuestions = (button: Element): void => {
  button.innerHTML = '';
  button.classList.add(
    ...['ehs-button', 'button-gray', 'button-medium', 'icon-button']
  );
  button.setAttribute('aria-label', intl('common.remove'));

  // Create a container element for the React content
  const contentContainer = document.createElement('span');
  const root = createRoot(contentContainer);
  root.render(<Icon iconName="shui_delete" aria-label="" />);

  button.appendChild(contentContainer);
};
